const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const clientsService = {
  // Get client document form data (createDocument)
  getClientDocumentFormData: async (clientId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/clients/${clientId}/documents/create`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: data.success,
        data: data.data,
        message: data.message || "Document form data retrieved successfully",
      };
    } catch (error) {
      console.error("Error getting client document form data:", error);
      return {
        success: false,
        message: error.message || "Error getting document form data",
      };
    }
  },

  // Create client document (storeDocument)
  createClientDocument: async (clientId, documentData) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/clients/${clientId}/documents`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(documentData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      return {
        success: true,
        data: data.data,
        message: "Document created successfully",
      };
    } catch (error) {
      console.error("Error creating client document:", error);
      return {
        success: false,
        message: error.message || "Error creating document",
      };
    }
  },

  // Get client document edit data (editDocument)
  editClientDocument: async (documentId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/clients/documents/${documentId}/edit`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: data.success,
        data: data.data,
        message: data.message || "Document edit data retrieved successfully",
      };
    } catch (error) {
      console.error("Error getting client document edit data:", error);
      return {
        success: false,
        message: error.message || "Error getting document edit data",
      };
    }
  },

  // Update client document (updateDocument)
  updateClientDocument: async (documentId, formData) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/clients/documents/${documentId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: data.success,
        data: data.data,
        message: data.message || "Document updated successfully",
      };
    } catch (error) {
      console.error("Error updating client document:", error);
      return {
        success: false,
        message: error.message || "Error updating document",
      };
    }
  },

  // Delete client document (deleteDocument)
  deleteClientDocument: async (documentId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/clients/documents/${documentId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: data.success,
        message: data.message || "Document deleted successfully",
      };
    } catch (error) {
      console.error("Error deleting client document:", error);
      return {
        success: false,
        message: error.message || "Error deleting document",
      };
    }
  },
};

export default clientsService;





















